// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"35853dea","977":"5ef9f254"}[chunkId] + ".chunk.js";
};